import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Table, Button, ButtonToolbar } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Actions from './Actions';
import { handleError } from '../../shared/ErrorCatching';
import notify from '../../shared/feedback/notifications';
import DeleteButton from '../../components/common/DeleteButton';
import { IInvoiceProductTypeListItem } from './Types';
import InvoiceProductTypeListRow from './InvoiceProductTypeListRow';
import InvoiceProductTypeModal from './InvoiceProductTypeModal';

interface IInvoiceProductTypeListPageProps {
    actions: IInvoiceProductTypeListPageActions;
    list: IInvoiceProductTypeListItem[];
    site: string;
}
interface IInvoiceProductTypeListPageState {
    displayEditModal: boolean;
    currentEditingId?: number;
}
interface IInvoiceProductTypeListPageActions {
    list: () => Promise<void>;
    delete: (id: number) => Promise<void>;
}

class InvoiceProductTypeListPage extends React.Component<
    IInvoiceProductTypeListPageProps,
    IInvoiceProductTypeListPageState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            displayEditModal: false,
            currentEditingId: null
        } as IInvoiceProductTypeListPageState;

        this.load = this.load.bind(this);
        this.delete = this.delete.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount(): void {
        this.load();
    }

    load(): void {
        this.props.actions.list().catch((error: any) => handleError(error));
    }

    openModal(id?: number): void {
        this.setState({
            currentEditingId: id ? id : null,
            displayEditModal: true
        });
    }

    closeModal(): void {
        this.setState({ currentEditingId: null, displayEditModal: false });
    }

    delete(id: number): void {
        this.props.actions.delete(id).catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('invoice-product-types/page/title')}</h1>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={(e) => this.openModal()}
                    bsStyle="success"
                >
                    {Translate('invoice-product-types/page/button/add-invoice-product-types')}
                </Button>
                <Table hover responsive>
                    <thead>
                        <tr>
                            <th>{Translate('invoice-product-types/page/list/head/name')}</th>
                            <th>{Translate('invoice-product-types/page/list/head/site')}</th>
                            <th>{Translate('invoice-product-types/page/list/head/is-system-default')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.list.map((item) => (
                            <InvoiceProductTypeListRow
                                key={item.id}
                                item={item}
                                edit={(id) => this.openModal(id)}
                                delete={(id) => this.delete(id)}
                                site={this.props.site}
                            />
                        ))}
                    </tbody>
                </Table>
                {this.state.displayEditModal && (
                    <InvoiceProductTypeModal
                        id={this.state.currentEditingId}
                        close={this.closeModal}
                        load={this.load}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        list: state.invoiceProductType.list,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            list: () => dispatch(Actions.list()),
            delete: (id) => dispatch(Actions.deleteItem(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceProductTypeListPage);
